import {
  LoginAPIRawRequestBodyType,
  LoginAPIRequestBodyType
} from '../../types/login-response/api-request-body';

export const LoginAPIRequestBody = ({
  email,
  password
}: LoginAPIRequestBodyType): LoginAPIRawRequestBodyType => ({
  email,
  password
});
